import { useResourceHistory } from './use-resource-history';

/**
 * ViewModel for the Skills detail revision history. Thin wrapper around the
 * generic `useResourceHistory`.
 */
export function useSkillHistory(
  skillId: string | null,
  options: { enabled?: boolean } = {},
) {
  return useResourceHistory('skill', skillId, options);
}
